import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ContactType, SocNetworkType } from '../../../types/common.type'

@Component({
  selector: 'bmcore-soc-media-input',
  templateUrl: './bmcore-soc-media-input.component.html',
  styleUrls: ['./bmcore-soc-media-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSocMediaInputComponent implements OnInit {
  @Input() socContact: ContactType
  @Input() placeholder: string
  @Output() updateContactsEvent = new EventEmitter<ContactType>()

  lg: LgType
  link = ''

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  changeInputValueHandler(e: Event) {
    this.link = (e.currentTarget as HTMLInputElement).value
  }

  blurHandler() {
    const link = this.link.trim()

    if (link) {
      const contact: ContactType = {
        link,
        type: this.socContact.type
      }

      this.updateContactsEvent.emit(contact)
    }
  }

  deleteHandler(type: SocNetworkType) {
    this.link = ''
    this.updateContactsEvent.emit({ type, link: '' })
  }
}
